import { ReadContractor } from "@/types/contractor";
import { useContractorContext } from "../context";

/**
 * Hook to get safe contractor data from context
 */
export const useContractorData = (): ReadContractor => {
  const { data, loadingState, errorState } = useContractorContext();

  if (loadingState.isLoading) {
    throw new Error("Contractor data is still loading");
  }
  if (errorState.error) {
    throw errorState.error;
  }
  if (!data) {
    throw new Error("No contractor data available");
  }

  return data;
};
